import React from "react";
import "./ProjectDetails.css";
import { ProjectContext } from "../context/ProjectContext";

const ProjectLocation = () => {
  const { projectDetails, loadingProject } =
    React.useContext(ProjectContext);

  if (loadingProject || !projectDetails) {
    return <div>Loading location...</div>;
  }

  /* ===== Safe Values ===== */
  const stateName =
    projectDetails?.state_name || "Not Available";

  const districtName =
    projectDetails?.district_name || "Not Available";

  const talukaName =
    projectDetails?.taluka_name || "Not Available";

  const totalVillages =
    projectDetails?.total_villages || 0;

  const location =
    projectDetails?.location || "";

  return (
    <div className="card csr-card mt-4">
      {/* Header */}
      <div className="csr-card-header">
        <div className="csr-icon teal">
          <i className="fa-solid fa-location-dot"></i>
        </div>

        <h5 className="mb-0">Project Location</h5>
      </div>

      {/* Location Info */}
      <div className="row location-info">
        <div className="col-md-6 col-12">
          <div className="location-item">
            <span className="label">State</span>

            <strong>{stateName}</strong>
          </div>
        </div>

        <div className="col-md-6 col-12">
          <div className="location-item">
            <span className="label">District</span>

            <strong>{districtName}</strong>
          </div>
        </div>

        <div className="col-md-6 col-12 mt-3">
          <div className="location-item">
            <span className="label">Taluka</span>

            <strong>{talukaName}</strong>
          </div>
        </div>

      <div className="col-12 mt-4">
  <div className="location-item">
    <span className="label">
      Selected Villages
    </span>

    <div className="village-list mt-2">
      {projectDetails?.village_names?.length > 0 ? (
        projectDetails.village_names.map(
          (village, index) => (
            <span
              key={index}
              className="village-badge"
            >
              {village}
            </span>
          )
        )
      ) : (
        <span>No villages selected</span>
      )}
    </div>
  </div>
</div>
      </div>

      {/* Google Map */}
      {location ? (
        <div className="map-box mt-4">
          <iframe
            title="Project Location Map"
            src={`https://www.google.com/maps?q=${encodeURIComponent(
              location
            )}&output=embed`}
            width="100%"
            height="400px"
            style={{
              border: 0,
              borderRadius: "10px",
            }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>
      ) : (
        <div className="text-muted mt-4">
          Location map not available
        </div>
      )}
    </div>
  );
};

export default ProjectLocation;